<template>
  <div class="white-container full-page-container common-table">
    <el-button v-if="search.type === 2" size="small" type="primary" icon="el-icon-plus" style="position: absolute;top: -50px;right: 0;" @click="add">新增专题活动相册</el-button>
    <el-button v-if="search.type === 8" size="small" type="primary" icon="el-icon-plus" style="position: absolute;top: -50px;right: 0;" @click="add">新增活动相册</el-button>
    <el-form class="search-bar" :inline="true" size="small">
      <el-form-item label="活动类型">
        <el-select ref="statusBox" v-model="search.type" placeholder="选择活动类型">
          <el-option label="Ua Star" :value="0" />
          <el-option label="专题活动" :value="1" />
          <el-option label="专题活动相册" :value="2" />
          <el-option label="社群活动相册" :value="8" />
          <el-option label="训练营" :value="7" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="searchSubmit">查询</el-button>
        <el-button @click="reset">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table ref="multipleTable" size="small" :data="list" style="width: 100%; margin-top:20px;">
      <el-table-column prop="objectId" label="项目ID" fixed />
      <el-table-column prop="type" label="活动类型">
        <template v-slot="{row}">
          <span v-if="row.type ===0">Ua Star</span>
          <span v-else-if="row.type ===1">专题活动</span>
          <span v-else-if="row.type ===2">专题活动相册</span>
          <span v-else-if="row.type ===8">社群活动相册</span>
          <span v-else>训练营</span>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="活动名称" />
      <el-table-column prop="beginTime" label="活动开始时间" width="140px">
        <template v-slot="{row}">
          {{ formatTime(row.beginTime) }}
        </template>
      </el-table-column>
      <el-table-column prop="photosNum" label="照片数量" />
      <el-table-column prop="updateTime" label="上传时间" />
      <el-table-column fixed="right" width="200px" label="操作">
        <template v-slot="{row}">
          <template v-if="row.type == 2 || row.type == 8">
            <el-button size="small" type="text" class="link-color" @click="editSpecial(row)">编辑</el-button>
            <el-button size="small" type="text" class="link-color" @click="removeSpecial(row)">删除</el-button>
            <el-button v-if="row.status === 0" size="small" type="text" class="link-color" @click="soldOut(row)">下架</el-button>
            <el-button v-if="row.status !== 0" size="small" type="text" class="link-color" @click="publish(row)">发布</el-button>
          </template>
          <template v-else>
            <el-button size="small" type="text" class="link-color" @click="edit(row)">编辑</el-button>
            <el-button size="small" type="text" class="link-color" @click="remove(row)">删除</el-button>
          </template>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background class="fixed-below" :page-size="pageSize" layout="total, prev, pager, next, sizes" :page-sizes="[10, 20, 50, 100]" :current-page.sync="pageNum" :total="total" @size-change="handleSizeChange" @current-change="getList" />
    <Dialog v-if="formDialogShow" v-model="formDialogShow" :information="information" @submit-success="submitSucces" />
    <Dialog v-if="dialogShow" v-model="dialogShow" :information="info" @submit-success="confirmSuccess" />
  </div>
</template>
<script>
import Dialog from '@/components/Dialog';
import moment from "moment";
export default {
  components: { Dialog },
  data() {
    return {
      search: {
        type: 0,
      },
      row: {},
      list: [],
      pageSize: 10,
      pageNum: 0,
      total: 0,
      formDialogShow: false,
      dialogShow: false,
      info: {},
      currentID: -1,
      information: {},
    };
  },
  computed: {
  },
  mounted() {
    this.getList();
  },
  methods: {
    add() {
      this.$router.push({ path: '/activity/photo_of_special/add', query: { isAssociation: this.search.type } });
    },
    // 相册二次确认弹窗
    confirmSuccess(operation) {
      if (operation === 'down') {
        this.$Api.activity.soldOutSpecialHighlightMoment(this.row.id).then(res => {
          this.$message({ message: '下架成功', type: 'success' });
          this.getList();
        });
      } else if (operation === 'up') {
        this.$Api.activity.publishSpecialHighlightMoment(this.row.id).then(res => {
          this.$message({ message: '发布成功', type: 'success' });
          this.getList();
        });
      } else if (operation === 'edit') {
        this.$router.push({ path: '/activity/photo_of_special/edit', query: { id: this.row.id, isAssociation: this.search.type } });
      } else if (operation === 'delete') {
        this.$Api.activity.deleteSpecialHighlightMoment(this.row.id).then(res => {
          this.$message({ message: '删除成功', type: 'success' });
          this.getList();
        });
      }
    },
    formatTime(time) {
      if (!time) return;
      return moment(time).format('YYYY/MM/DD h:mma');
    },
    searchSubmit() {
      this.searchSubmitted = {};
      Object.keys(this.search).forEach(key => {
        this.searchSubmitted[key] = this.search[key];
      });
      console.info(this.searchSubmitted);
      this.pageNum = 0;
      this.getList();
    },
    reset() {
      this.searchSubmitted = {};
      this.search = {
        type: 0,
      };
      this.pageNum = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    getList() {
      this.$Api.activity.postMemberList({
        type: this.search.type,
        limit: this.pageSize,
        current: this.pageNum,
        ...this.searchSubmitted,
      }).then(({ data, total }) => {
        this.list = data;
        this.total = total;
      });
    },
    // 下架
    soldOut(row) {
      this.row = row;
      this.info = {
        operation: 'down',
        icon: 'warn',
        subTitle: `下架后小程序用户将无法查看该相册，请确认`,
      };
      this.dialogShow = true;
    },
    // 发布
    publish(row) {
      this.row = row;
      this.info = {
        operation: 'up',
        icon: 'warn',
        subTitle: `发布后小程序用户将能够实时查看该相册，请确认`,
      };
      this.dialogShow = true;
    },
    editSpecial(row) {
      this.row = row;
      if (row.photosNum > 0) {
        this.dialogShow = true;
        this.info = {
          operation: 'edit',
          icon: 'warn',
          subTitle: `编辑操作将会更新已有的${row.type === 8 ? '社群相册' : '专题活动'}照片，是否继续？`,
        };
      } else {
        this.$router.push({ path: '/activity/photo_of_special/edit', query: { id: row.id, isAssociation: row.type } });
      }
    },
    edit(row) {
      if (row.photosNum > 0) {
        this.formDialogShow = true;
        this.currentID = row.objectId;
        this.information = {
          operation: 'edit',
          icon: 'warn',
          subTitle: `编辑操作将会更新已有的活动照片，是否继续？`,
        };
        this.row = row;
      } else {
        this.$router.push({ path: '/activity/photo/edit', query: { id: row.objectId, objectType: this.search.type === 7 ? 7 : 3, type: this.search.type } });
      }
    },
    remove(row) {
      this.formDialogShow = true;
      this.currentID = row.objectId;
      this.information = {
        operation: 'delete',
        icon: 'warn',
        // subTitle: `是否确认删除项目ID为“${row.objectId}”的数据项？`,
        subTitle: '删除后小程序用户将无法查看该活动照片/视频列表，请确认是否删除',
      };
    },
    removeSpecial(row) {
      this.row = row;
      this.dialogShow = true;
      this.info = {
        operation: 'delete',
        icon: 'warn',
        subTitle: '删除后小程序用户将无法查看该专题活动照片/视频列表，请确认是否删除',
      };
    },
    submitSucces(operation) {
      if (operation === 'delete') {
        this.$Api.activity.deleteHighlightMoment(this.search.type === 7 ? 7 : 3, this.currentID).then(() => {
          this.$message({ message: '删除成功', type: 'success' });
          this.getList();
        });
      } else if (operation === 'edit') {
        this.$router.push({ path: '/activity/photo/edit', query: { id: this.currentID, objectType: this.search.type === 7 ? 7 : 3, type: this.search.type } });
      }
    },
  },
};

</script>
